import { EmailSettingsTab } from "@/components/settings/EmailSettingsTab";

export function SettingsEmailPage() {
  return <EmailSettingsTab />;
}
